export default "__VITE_ASSET__6822527e__"